import { Component, NgZone, OnInit } from '@angular/core';
import { SNAgendaAppointment } from 'src/app/models/snagendaappointment';
import { AgendaService } from 'src/app/services/agenda.service';
import { BecareService } from 'src/app/services/becare.service';
import { PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';

declare var Ext: any;
declare var gUser: any;

@Component({
  selector: 'app-agenda-waiting-header',
  templateUrl: './agenda-waiting-header.component.html',
  styleUrls: ['./agenda-waiting-header.component.scss']
})
export class AgendaWaitingHeaderComponent implements OnInit {

  public appointments: SNAgendaAppointment[] = [];

  constructor(private userConfig: UserConfigService, private agenda: AgendaService,
              private patient: PatientService, private becare: BecareService,
              private ngZone: NgZone) {
    if (this.userConfig.loaded) {
      this.reload();
    } else {
      this.userConfig.configLoaded.subscribe(config => {
        this.reload();
      });
    }
    this.agenda.loadAgendas();
  }

  ngOnInit(): void {
  }

  reload(): void {
    this.agenda.userAppointments(this.userConfig.user, 'all', 'today', [['Status', 'In']]).subscribe(appointments => {
      this.appointments = appointments;
    });
  }

  openUserAgenda(): void {
    this.agenda.currentAgenda().subscribe(agenda => {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          const agendaWindow = new Ext.CNAgendaWindow({
                selectedUser: gUser,
                selectedAgendaId: agenda.id});
          agendaWindow.show();
        });
      });
    });
  }

  selectAppointment(appointment: SNAgendaAppointment): void {
    // Check appointment group
    console.log('selected appointment', appointment);
    let domainid = 0;
    if (typeof((appointment as any).domain) !== 'undefined') {
      domainid = parseInt((appointment as any).domain.ID, 10);
    }
    if (!this.userConfig.domainIdIsMainGroup(domainid)) {
      // Switch domain
      const currentGroup = this.userConfig.currentGroup();
      console.log('SWITCH DOMAIN BEFORE SELECTING PATIENT');
      this.becare.call('/user/' + this.userConfig.userid  + '/domain/' + currentGroup[0], [], undefined, 'delete').subscribe(() => {
        // Set current group
        this.becare.call('/user/' + this.userConfig.userid  + '/domain/' + domainid.toString(), [], undefined, 'put').subscribe(() => {
          // Reload user config
          this.userConfig.loadConfig();
          // select patient
          this.patient.select(parseInt(appointment.properties.PatientID, 10)).subscribe();
        });
      });
    } else {
      // select patient
      this.patient.select(parseInt(appointment.properties.PatientID, 10)).subscribe();
    }
  }
}
